<template>
    <div class="supportedby" id="supportedby" v-if="this.supportedby.length > 0">
        <h2>{{ARTICLE.defaultlang=='zh'?'支撑数据':'Supportedby'}}</h2>
      <div v-for="item in this.supportedby">
        <component :is="'jo' + item1.name" v-for="item1 in item.data" v-bind:key="item1.index" v-bind:data="item1.data"></component>
      </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                supportedby: this.ARTICLE.supportedby
            }
        },
        created() {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/maincontent/body/supportedby/supportedby.vue